'use client';

import Script from 'next/script';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { useUser } from '@/app_lib/providers/UserProvider';
import { OutbrainLoadingState } from '@/app_lib/services/Outbrain/config';

export const OutbrainScript = () => {
  const { personalizedAds } = useUser();
  const { renderOutbrainScript, setOutbrainScriptLoadedState } = useAdContext();

  return (
    <>
      {renderOutbrainScript && personalizedAds !== null && (
        <Script
          onError={() => {
            setOutbrainScriptLoadedState(OutbrainLoadingState.Failed);
          }}
          onLoad={() => {
            setOutbrainScriptLoadedState(OutbrainLoadingState.Loaded);
          }}
          src='https://widgets.outbrain.com/outbrain.js'
          strategy='afterInteractive'
        />
      )}
    </>
  );
};
